export const classes = {
  optionsWrapper: 'flex justify-center items-start ml-3',
  optionsIcon: 'cursor-pointer text-taupe-2 dark:text-mauve-2',
};
